import { DarkMode as DarkModeIcon, LightMode as LightModeIcon } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

import type { ColorMode } from '@/utils/colorMode'

export interface ThemeToggleProps {
  mode: ColorMode
  onToggle: () => void
}

/** Light/dark switch, mirroring untool-mage's. */
export function ThemeToggle({ mode, onToggle }: ThemeToggleProps): React.JSX.Element {
  const target = mode === 'light' ? 'dark' : 'light'

  return (
    <Tooltip title={`Switch to ${target} mode`}>
      <IconButton onClick={onToggle} color='inherit' aria-label={`Switch to ${target} mode`}>
        {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
      </IconButton>
    </Tooltip>
  )
}
